import { render, staticRenderFns } from "./LayCatalogDatabase.vue?vue&type=template&id=65eef06e&scoped=true&"
import script from "./LayCatalogDatabase.vue?vue&type=script&lang=js&"
export * from "./LayCatalogDatabase.vue?vue&type=script&lang=js&"
import style0 from "./LayCatalogDatabase.vue?vue&type=style&index=0&id=65eef06e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eef06e",
  null
  
)

export default component.exports